import { ChangeDetectorRef, ElementRef, EventEmitter, Injectable, Input, KeyValueDiffers, Output, ViewChild, } from '@angular/core';
import * as _ from 'lodash-es';
import { MarkdownService } from './ngx-markdown.service';
export class MarkdownHoodClass {
    constructor(markdownService, changeDetectorRef, keyValueDiffers) {
        this.markdownService = markdownService;
        this.changeDetectorRef = changeDetectorRef;
        this.keyValueDiffers = keyValueDiffers;
        this.directive = false;
        this._change = false;
        this.templateOptions = { interpolate: /{{([\s\S]+?)}}/g };
        this.result = new EventEmitter();
        this.differ = {};
        this.differ = { options: this.keyValueDiffers.find(this.markdownService.config[0].options).create() };
    }
    set change(value) {
        this.changeDetectorRef.markForCheck();
        this._change = value;
        this.markdownToHtml();
    }
    get change() {
        return this._change;
    }
    errorHandler(error) {
        throw new Error(error);
    }
    ;
    init(string, change = true, resolved, error) {
        if (typeof (change) === 'boolean' && typeof (this.change) === 'boolean' && this.change === change) {
            if (typeof (string) === 'string' && string) {
                string = this.interpolate(string);
                this.promiseHandler(this.markdownService.marked(string, this.options, this.callback), resolved, error);
            }
        }
    }
    onChanges(prop, changes) {
        if (changes) {
            _.each(changes, (value, key) => {
                if (prop instanceof Array) {
                    _.each(prop, (propName) => {
                        if (key === propName) {
                            if (changes[key].currentValue !== changes[key].previousValue) {
                                this.stringMarked = undefined;
                                this.change = true;
                            }
                        }
                    });
                }
                else {
                    switch (key) {
                        case prop:
                            if (changes[key].currentValue !== changes[key].previousValue) {
                                this.stringMarked = undefined;
                                this.change = true;
                            }
                            break;
                    }
                }
            });
        }
    }
    promiseHandler(promise, resolved, error) {
        if (promise instanceof Promise) {
            promise
                .catch(error ? error : this.errorHandler)
                .then(resolved);
        }
    }
    storeNgContent() {
        if (!this.ngContent) {
            this.ngContent = this.el.nativeElement.innerHTML;
        }
    }
    interpolate(string) {
        if (this.interpolation && typeof this.interpolation === 'object') {
            string = _.template(string, this.templateOptions)(this.interpolation);
        }
        return string;
    }
    markdownToHtml() {
        if (this.string) {
            this.init(this.string, true, (result) => {
                if (result) {
                    this.result.emit(result);
                    if (this.directive === false) {
                        this.stringMarked = result;
                        this._change = false;
                        this.changeDetectorRef.markForCheck();
                    }
                    else {
                        if (this.el) {
                            this.el.nativeElement.innerHTML = result;
                        }
                    }
                }
            });
        }
        else {
            if (this.el) {
                this.init(this.ngContent, true, (result) => {
                    if (result) {
                        this.result.emit(result);
                        if (this.directive === false) {
                            this.el.nativeElement.innerHTML = result;
                            this._change = false;
                            this.changeDetectorRef.markForCheck();
                        }
                        else {
                            this.el.nativeElement.innerHTML = result;
                            this._change = false;
                        }
                    }
                });
            }
        }
    }
}
MarkdownHoodClass.decorators = [
    { type: Injectable },
];
MarkdownHoodClass.ctorParameters = () => [
    { type: MarkdownService, },
    { type: ChangeDetectorRef, },
    { type: KeyValueDiffers, },
];
MarkdownHoodClass.propDecorators = {
    'callback': [{ type: Input, args: ['callback',] },],
    'interpolation': [{ type: Input, args: ['interpolation',] },],
    'options': [{ type: Input, args: ['options',] },],
    'string': [{ type: Input, args: ['string',] },],
    'result': [{ type: Output, args: ['result',] },],
    'el': [{ type: ViewChild, args: ['el', { read: ElementRef },] },],
};
//# sourceMappingURL=ngx-markdown.class.js.map